import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale);

const Kpichart = forwardRef(({ chartData, options }, ref) => {
    const chartRef = useRef(null);

    useImperativeHandle(ref, () => ({
        chartInstance: chartRef.current?.chart, // Ensure the chart instance is accessible
    }), []);

    return (
        <div style={{ width: '100%', height: '400px' }}> {/* Ensure height is specified */}

            <Line
                data={chartData}
                options={options}
                ref={chartRef}
            />
        </div>
    );
});

export default Kpichart;
